getEmailCustomerServiceUrl